<template>
    <div class="add-publish flex-column">
        <div class="add-publish-icons"><i class="el-icon-circle-check-outline"></i></div>
        <h1>保存成功，请在我的漫画中提交审核</h1>
        <el-button type="primary" size="large" @click="addChapterAgain">继续添加章节</el-button>
    </div>
</template>

<script>
/*
 * @Author: daipeng
 * @Date: 2018-10-16 17:38:39
 * @LastEditors: OBKoro1
 * @LastEditTime: 2018-10-16 18:40:56
 * @Description: 新增漫画发布审核
 * @Company: 成都二次元动漫
 */

export default {
    data() {
        return {};
    },
    methods: {
        addChapterAgain() {
            const { comicName, comicId, uploaderUid, authorName } = this.$route.query;
            this.$router.replace({ name: 'addChapter', query: { editType: 'add', comicName, comicId, uploaderUid, authorName } });
        }
    }
};
</script>

<style lang="scss">
    .add-publish{
        height: 100%;
        justify-content: center;
        align-items: center;
        &-icons{
            i{
               color: #67c23a;
               font-size: 60px;
            }
        }
    }
</style>
